import { __assign, __rest } from "tslib";
import React from 'react';
import { Wrapper } from './table.style';
export var Table = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, striped = _a.striped, hoverable = _a.hoverable, ref = _a.ref, props = __rest(_a, ["children", "className", "striped", "hoverable", "ref"]);
    return (React.createElement(Wrapper, __assign({ className: "legion-table ".concat(className, " ").concat(striped ? 'striped' : hoverable ? 'hoverable' : ''), ref: ref }, props), children));
};
